module.exports = __webpack_public_path__ + "img/victrix-bretelle-5.e7468d10.jpg";